












import { Vue, Component, Prop, Watch, Emit, Ref } from "vue-property-decorator";
import { Mutation, Getter } from "vuex-class";
import Header from "@/components/header.vue";

import BottomNavigation, {
  INavigationItem
} from "@/components/bottom-navigation.vue";
@Component({
  name: "home",
  components: {
    BottomNavigation,
    Header
  }
})
export default class Home extends Vue {
  @Getter("headerTitle") headerTitle!: string;
  @Getter("isPc") isPc!: boolean;
  @Getter("merchId") merchId!: string;

  @Watch("merchId")
  saveDataInStorage() {
    if (this.$store.state.openInBrowser) {
      sessionStorage.setItem("token", this.$store.state.options.token);
      sessionStorage.setItem("merchId", this.$store.state.merchId);
      sessionStorage.setItem("oauthType", this.$store.state.options.oauthType);
      sessionStorage.setItem(
        "loginMerchant",
        JSON.stringify(this.$store.state.loginMerchant)
      );
    }
  }

  navigationItem: INavigationItem[] = [];

  onBottonNavChange(tabIndex: number) {
    this.navigationItem[tabIndex].text;
    this.$router.push({ name: this.navigationItem[tabIndex].text });
  }

  created() {
    if (this.isPc) {
      this.navigationItem = [
        {
          text: "Orders",
          icon: "mdi-clipboard-list-outline",
          showBadge: false
        },
        { text: "Messages", icon: "mdi-bell-ring-outline", showBadge: true }
      ];

      return;
    }
    this.navigationItem = [
      {
        text: "Orders",
        icon: "mdi-clipboard-list-outline",
        showBadge: false
      },
      { text: "Menu", icon: "mdi-widgets", showBadge: false },
      { text: "Messages", icon: "mdi-bell-ring-outline", showBadge: true },
      { text: "Settings", icon: "mdi-progress-wrench", showBadge: false }
    ];
  }
}
